<div class="modal__overlay">
  <div #container class="modal__container f-c">
    <div class="modal__content">
      <ng-template #content></ng-template>
    </div>
  </div>
</div>
